import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';

// Multibrand-UI Components
import Col from '@zg-rentals/multibrand-ui/lib/Col';
import Row from '@zg-rentals/multibrand-ui/lib/Row';
import Text from '@zg-rentals/multibrand-ui/lib/Text';

// containers
import AuthCheckWrapper from 'app/shared/containers/AuthCheckWrapper';

// Components
import HeadWrapper from 'app/shared/components/HeadWrapper';
import TableMFH from 'app/shared/components/TableMFH';
import SpinnerContainer from 'app/shared/components/SpinnerContainer';

// Selectors
import { AppSelectors, UserManagementSelectors, UserSelectors } from 'app/shared/selectors';

// Constants
import ModalConstants from 'app/shared/constants/ModalConstants';

// Actions
import ModalActions from 'app/shared/actions/ModalActions';
import UserManagementActions from 'app/shared/actions/UserManagementActions';

import columnConfigs from './columnConfigs';

// Stylesheets
import './style.scss';

const propTypes = {
};

const UsersPage = ({
    isScreenMobile,
    dispatch,
    company,
    companyUsers,
    activeTab,
    user,
    users,
}) => {
    const handleResendInvite = (invitedUser) => {
        dispatch(ModalActions.showModal({
            modalType: ModalConstants.RESEND_COMPANY_INVITE_MODAL,
            targetEmail: invitedUser.email,
            userName: invitedUser.userName,
            header: 'Resend invite',
            onClose: () => dispatch(ModalActions.hideModal()),
            onSubmit: () => {
                dispatch(UserManagementActions.resendInviteEmail(invitedUser))
                    .then(() => dispatch(ModalActions.hideModal()));
            },
            useModalDialog: false,
        }));
    };

    const columnConfig = columnConfigs.getConfigs(isScreenMobile, dispatch,
        handleResendInvite, company, user.userToken, activeTab);
    const isLoading = company.isLoading || companyUsers.isLoading;
    const renderEmptyTableMessage = () => {
        if (users.length !== 0 || companyUsers.isLoading) {
            return null;
        }
        return (
            <Row>
                <Col>
                    <Text className="empty-message">No Users Found</Text>
                </Col>
            </Row>
        );
    };

    const renderContent = () => {
        if (companyUsers.error || company.error) {
            return (
                <Row>
                    <Col>
                        <Text danger={true}>
                            Cannot retrieve user management information. Please try again later.
                        </Text>
                    </Col>
                </Row>
            );
        }

        return (
            <React.Fragment>
                <TableMFH
                    columnConfig={columnConfig}
                    data={users}
                    idKey="email"
                />
                {renderEmptyTableMessage()}
            </React.Fragment>
        );
    };

    return (
        <AuthCheckWrapper requireStrongAuthentication={false}>
            <div className="UsersPage">
                <HeadWrapper title="Users" />
                {isLoading ? <SpinnerContainer /> : renderContent()}
            </div>
        </AuthCheckWrapper>
    );
};

const mapStateToProps = state => ({
    isScreenMobile: AppSelectors.makeIsScreenMobile(state),
    company: UserManagementSelectors.makeCompany(state),
    companyUsers: UserManagementSelectors.makeCompanyUsers(state),
    activeTab: UserManagementSelectors.makeActiveTab(state),
    user: UserSelectors.makeUser(state),
    users: UserManagementSelectors.makeUserList(state),
});

UsersPage.propTypes = propTypes;

export { UsersPage };
export default withRouter(connect(mapStateToProps)(UsersPage));
